/* LP Staffel-Checkout (A3/A6) – lovely-presents.de, 14.10.2026
 * Zeigt im Warenkorb (Seite + Schublade) die Staffelpreise des Dienstes an und leitet "Zur Kasse"
 * über den Dienst in einen Bestellentwurf mit Staffelpreisen. Der Browser schickt nur Varianten-ID,
 * Menge und Eigenschaften – die Preise rechnet ausschließlich der Server aus Shopify-Daten.
 * Repo: lovely-presents/theme/assets/lp-staffel-checkout.js · Dienst: tools/lp_staffel_checkout.py
 */
(function () {
  'use strict';
  var API = 'https://docs.gernevent.com/lp-checkout';
  var CONTACT = 'info@lovelypresents.de';
  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 4 });
  var fmt2 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var busy = false, applying = false, timer = null, lastKey = '';

  function money(v, unit) { return (unit ? fmt : fmt2).format(v); }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function itemsOf(cart, withProps) {
    return cart.items.map(function (it) {
      var o = { variant_id: it.variant_id, quantity: it.quantity };
      if (withProps) o.properties = it.properties || {};
      return o;
    });
  }

  function post(path, items) {
    return fetch(API + path, {
      method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false, error: 'service_unavailable' }; })
        .then(function (d) { d._status = r.status; return d; });
    });
  }

  function errorText(line) {
    if (line.error === 'below_minimum') return 'Mindestbestellmenge: ' + line.min_qty.toLocaleString('de-DE') + ' Stück';
    if (line.error === 'not_available') return 'Dieser Artikel ist derzeit nicht bestellbar.';
    if (line.error === 'no_price') return 'Preis auf Anfrage – bitte kontaktieren Sie uns.';
    return 'Bitte Menge prüfen.';
  }

  function orderText(q) {
    return 'Mindestbestellwert: ' + money(q.min_order_net, false) + ' netto (aktuell ' + money(q.subtotal_net, false) +
      '). Bitte Menge erhöhen oder weitere Artikel hinzufügen.';
  }

  function setPrice(el, value, unit) {
    if (!el) return;
    el.innerHTML = '<span class="visually-hidden">Preis</span>' + money(value, unit);
  }

  function note(row, html, isError) {
    var n = row.querySelector('.lp-staffel-note');
    if (!n) {
      n = document.createElement('p');
      n.className = 'lp-staffel-note text--xsmall';
      var meta = row.querySelector('.product-item-meta') || row;
      meta.appendChild(n);
    }
    n.style.color = isError ? '#c0392b' : '';
    n.style.margin = '6px 0 0';
    n.innerHTML = html;
  }

  function linePriceEls(row) {
    return Array.prototype.slice.call(row.querySelectorAll('.price-list .price:not(.price--compare)'))
      .filter(function (p) { return !p.closest('.unit-price-measurement') && !p.classList.contains('text--subdued'); });
  }

  function apply(quote) {
    applying = true;
    try {
      var hasError = !quote.ok;
      var lineError = quote.lines.some(function (l) { return l.error; });
      // Warenkorb-Seite
      var rows = document.querySelectorAll('.line-item-table__list > tr.line-item');
      // Warenkorb-Schublade
      var drawerRows = document.querySelectorAll('#mini-cart line-item.line-item');
      [rows, drawerRows].forEach(function (list) {
        Array.prototype.forEach.call(list, function (row, i) {
          var l = quote.lines[i];
          if (!l) return;
          if (l.error) {
            note(row, errorText(l), true);
            return;
          }
          var tierInfo = l.tier_min ? 'Staffelpreis ab ' + l.tier_min.toLocaleString('de-DE') + ' Stk.: ' : 'Stückpreis: ';
          note(row, tierInfo + money(l.unit_price, true) + ' netto', false);
          // Desktop-Stückpreis (Warenkorb-Seite) = erstes .price in .price-list.hidden-phone
          var unitEl = row.querySelector('.price-list.hidden-phone > .price:not(.text--subdued)');
          if (unitEl && row.tagName === 'TR') setPrice(unitEl, l.unit_price, true);
          linePriceEls(row).forEach(function (p) {
            if (p === unitEl && row.tagName === 'TR') return;
            setPrice(p, l.line_total, false);
          });
        });
      });
      // Mindestbestellwert-Hinweis (Seite + Schublade)
      ['.cart__recap', '#mini-cart .mini-cart__drawer-footer'].forEach(function (sel) {
        var box = document.querySelector(sel);
        if (!box) return;
        var m = box.querySelector('.lp-staffel-mov');
        if (quote.order_error === 'below_order_value') {
          if (!m) { m = document.createElement('p'); m.className = 'lp-staffel-mov text--small'; box.insertBefore(m, box.firstChild); }
          m.style.cssText = 'color:#c0392b;margin:0 0 12px';
          m.innerHTML = orderText(quote);
        } else if (m) { m.remove(); }
      });
      // Summen
      if (!lineError) {
        var total = money(quote.subtotal_net, false);
        var t = document.querySelector('.cart__total-container span:last-child');
        if (t) t.textContent = total + ' netto';
        var btn = document.querySelector('#mini-cart button[name="checkout"]');
        if (btn) {
          var sep = btn.querySelector('.square-separator');
          if (sep) { while (sep.nextSibling) btn.removeChild(sep.nextSibling); btn.appendChild(document.createTextNode(total)); }
        }
      }
      document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
        b.toggleAttribute('data-lp-blocked', hasError);
        b.style.opacity = hasError ? '0.5' : '';
        b.title = hasError ? 'Bitte zuerst die Hinweise im Warenkorb beachten.' : '';
      });
    } finally {
      setTimeout(function () { applying = false; }, 50);
    }
  }

  function refresh() {
    if (!document.querySelector('.line-item-table__list, #mini-cart line-item')) return;
    getCart().then(function (cart) {
      if (!cart.items.length) return;
      var key = JSON.stringify(itemsOf(cart, false));
      if (key === lastKey && document.querySelector('.lp-staffel-note')) return;
      lastKey = key;
      return post('/quote', itemsOf(cart, false)).then(function (q) { if (q && q.lines) apply(q); });
    }).catch(function () { /* Anzeige ist optional; die Kasse prüft erneut */ });
  }

  function schedule() {
    if (applying) return;
    clearTimeout(timer);
    timer = setTimeout(function () { lastKey = ''; refresh(); }, 300);
  }

  function showMessage(html) {
    var box = document.getElementById('lp-staffel-msg');
    if (!box) {
      box = document.createElement('div');
      box.id = 'lp-staffel-msg';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
        'max-width:min(560px,calc(100vw - 32px));background:#fff;color:#1a1a1a;border:1px solid #c0392b;border-radius:6px;' +
        'padding:14px 40px 14px 16px;box-shadow:0 6px 24px rgba(0,0,0,.18);font-size:14px;line-height:1.45';
      var x = document.createElement('button');
      x.type = 'button'; x.textContent = '×'; x.setAttribute('aria-label', 'Schließen');
      x.style.cssText = 'position:absolute;top:6px;right:10px;background:none;border:0;font-size:22px;cursor:pointer;color:inherit';
      x.onclick = function () { box.remove(); };
      box.appendChild(document.createElement('div'));
      box.appendChild(x);
      document.body.appendChild(box);
    }
    box.firstChild.innerHTML = html;
  }

  function goCheckout(trigger) {
    if (busy) return;
    busy = true;
    if (trigger) { trigger.setAttribute('aria-busy', 'true'); trigger.style.opacity = '0.6'; }
    getCart().then(function (cart) {
      if (!cart.items.length) { window.location.href = '/cart'; return; }
      return post('/checkout', itemsOf(cart, true)).then(function (d) {
        if (d.ok && d.invoice_url) { window.location.href = d.invoice_url; return; }
        if (d.lines) {
          apply(d);
          var msgs = d.lines.filter(function (l) { return l.error; }).map(function (l) {
            return '<li>' + (l.title ? l.title + ': ' : '') + errorText(l) + '</li>';
          });
          if (d.order_error === 'below_order_value') msgs.push('<li>' + orderText(d) + '</li>');
          showMessage('<strong>Bitte Warenkorb anpassen:</strong><ul style="margin:6px 0 0 18px">' + msgs.join('') + '</ul>');
          return;
        }
        throw new Error(d.error || 'unavailable');
      });
    }).catch(function () {
      showMessage('<strong>Die Kasse ist gerade nicht erreichbar.</strong> Bitte versuchen Sie es in einigen Minuten erneut ' +
        'oder schreiben Sie uns an <a href="mailto:' + CONTACT + '">' + CONTACT + '</a>.');
    }).then(function () {
      busy = false;
      if (trigger) { trigger.removeAttribute('aria-busy'); trigger.style.opacity = ''; }
    });
  }

  // Alle Wege zur Kasse abfangen (Formulare mit name="checkout", Links auf /checkout).
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var sub = e.submitter;
    var isCheckout = (sub && sub.name === 'checkout') || (f && f.querySelector && f.querySelector('input[name="checkout"]') &&
      /\/cart\/?(\?|$)/.test((f.getAttribute('action') || '')));
    if (!isCheckout) return;
    e.preventDefault(); e.stopImmediatePropagation();
    goCheckout(sub || null);
  }, true);

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/^(https?:\/\/[^/]*lovely-presents[^/]*)?\/checkout(\/|\?|$)/.test(href)) {
      e.preventDefault(); e.stopImmediatePropagation();
      goCheckout(a);
    }
  }, true);

  // Express-Knöpfe (Shop Pay, Jetzt kaufen) umgehen die Staffelberechnung -> ausblenden.
  var css = document.createElement('style');
  css.textContent = '.shopify-payment-button,.additional-checkout-buttons,shopify-accelerated-checkout,' +
    'shopify-accelerated-checkout-cart,.product-form__payment-container .shopify-payment-button{display:none!important}' +
    '.lp-staffel-note{display:block}';
  document.head.appendChild(css);

  // Anzeige aktuell halten (Focal rendert Warenkorb/Schublade per Ajax neu).
  new MutationObserver(function (muts) {
    if (applying) return;
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.closest && (t.closest('#mini-cart') || t.closest('.cart'))) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('variant:added', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
